// extracted by mini-css-extract-plugin
export default {"sidebar":"AdminLayout_sidebar__cdDw1","open":"AdminLayout_open__R3BMY","closeButton":"AdminLayout_closeButton__qya4l","heading":"AdminLayout_heading__wu4k7"};